import { useQueryClient, useMutation } from '@tanstack/react-query'
import { useSelector } from 'react-redux'
import { contextCompanyIdSelector } from '../../../redux/context/company/selectors'
import { updateFormula } from '../service/formulaService'
import { Formula } from '../types/Formula'
import formulaQueryKeys from './formulaQueryKeys'
import { showSuccessMessage } from '../../../utils/message'

export const useUpdateFormula = () => {
  const companyId = useSelector(contextCompanyIdSelector)!
  const queryClient = useQueryClient()

  return useMutation({
    mutationKey: ['budget', 'formula', 'update'],
    mutationFn: (data: Formula) => updateFormula(data.id, data, companyId),
    onSuccess() {
      queryClient.invalidateQueries({ queryKey: formulaQueryKeys.list({ companyId }) })
      showSuccessMessage()
    }
  })
}
